export default __webpack_public_path__ + "static/media/106t.ce849240.jpg";